export const replacePolishCharacters = (inputValue: string) => {
	const letters = ['ą', 'ć', 'ę', 'ł', 'ń', 'ó', 'ś', 'ź', 'ż'];
	const replacement = ['a', 'c', 'e', 'l', 'n', 'o', 's', 'z', 'z'];

	let result = inputValue?.toLowerCase();

	for (let i = 0; i < letters.length; ++i) {
		// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		result = result?.replaceAll(letters[i]!, replacement[i]!);
	}

	return result;
};
